import { gql } from '@apollo/client';

export const orderMultiTripQueryAffiliate = gql`
  mutation orderMultiTripTravel(
    $comparisonId: UUID!
    $chosenProductKrn: String!
    $request: MultiTripTravel_TravelOrderRequestInput!
  ) {
    orderMultiTripTravel(
      input: {
        comparisonId: $comparisonId
        chosenProductKrn: $chosenProductKrn
        frontEndName: "overstappen"
        request: $request
      }
    ) {
      multiTripTravel_OrderResult {
        orderId
      }
    }
  }
`;
